// ActionButtons.jsx
import React from "react";
import { motion } from "framer-motion";
import { MdEvent, MdReceipt, MdLocalPharmacy } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getValueFromToken } from "../../../utils/tokenUtils";

const ActionButtons = ({
  handleBookAppointment,
  handleCreateBill,
  patientId,
  prescriptionRedirectUrl = "/clinic/dashboard",
  handleCloseModal,
}) => {
  const navigate = useNavigate();

  const handleCreatePrescription = () => {
    handleCloseModal();
    navigate(
      `/clinic/generatePrescription?patientId=${patientId}&doctorId=${getValueFromToken(
        "doctor_id"
      )}&redirect=${prescriptionRedirectUrl}`
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      exit={{ opacity: 0, y: -50 }}
      className="flex flex-col space-y-2.5"
    >
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md mb-2 flex items-center justify-center"
        onClick={handleBookAppointment}
      >
        <MdEvent className="w-6 h-6 mr-2" />
        Create Appointment
      </motion.button>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-md mb-2 flex items-center justify-center"
        onClick={handleCreateBill}
      >
        <MdReceipt className="w-6 h-6 mr-2" />
        Create Bill
      </motion.button>
      <motion.button
        onClick={handleCreatePrescription}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-md flex items-center justify-center"
      >
        <MdLocalPharmacy className="w-6 h-6 mr-2" />
        Create Prescription
      </motion.button>
    </motion.div>
  );
};

export default ActionButtons;
